import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

import { ShareDirectivesModule } from '../../../../core/directives/directives.module';
import { SharePipesModule } from '../../../../core/pipes/pipes.module';
import { TranslationModule } from '../../../../i18n/translation.module';
import { ShareModule } from '../../../../shared/share.module';
import { PagesSharedModule } from '../../pages-shared.module';
import { MenuBtnComponent } from './../../../../shared/global/menu-btn/menu-btn.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    TranslationModule,
    MatMenuModule,
    ShareModule,
    PagesSharedModule,
    ShareDirectivesModule,
    SharePipesModule,
    MenuBtnComponent,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    TranslationModule,
    MatMenuModule,
    ShareModule,
    PagesSharedModule,
    ShareDirectivesModule,
    SharePipesModule,
    MenuBtnComponent,
  ],
})
export class BaseIndexModule {}
